import { useMemo, useState } from "react";

import Box from "../Box";
import Avatar from "../Avatar";
import Button from "../Button";
import DataTable from "../DataTable";
import Typography from "../Typography";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import useContainerStaff from "../../hooks/useContainerStaff";
import ModalInvitationMember from "../Staff/modalInvitationMember";
import ModalHandelDeleteMember from "../Staff/modalHandelDeleteMember";
import CustomStatusCell, { StatusByScreen } from "../CustomStatusCell";
import useContainerInvitation from "../../hooks/useContainerInvitation";
import ModalCreateUpdateMember from "../Staff/modalCreateUpdateMember";

import { Mode, Status } from "../../constants/enums";
import { Constants } from "../../constants/constants";
import { RoleHelpers } from "../../commons/roleHelpers";
import { IOrgUserProfile } from "../../hooks/useContainerOrganization";
import { ICodename, ILableOrganization } from "../../commons/interfaces";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";



interface IStaffStepProps {
    newDomain?: string;

    mode: number;
    organizationId: string;
    idGroupDefaultByOrg?: string;

    dataRoles: ICodename[];
    dataGroups: ICodename[];
    dataUserTitle: ICodename[];
    dataRowByStaff: IOrgUserProfile[];

    hidenActionUpdate: boolean;
    hidenActionDelete: boolean;
    hidenActionCreate: boolean;
    hidenActionInvation?: boolean;
    hidenActionDeleteAllService?: boolean,

    onCallBack: () => void;
    modalCreateMember?: (props: {
        groupId?: string;
        organizationId: string;
        dataRoles?: ICodename[];
        dataGroups?: ICodename[];
        onCallBack?: () => void
    }) => JSX.Element;
    modalUpdateMember?: (props: {
        groupId?: string;
        organizationId: string;
        idDetailStaff?: string;
        dataRoles?: ICodename[];
        dataGroups?: ICodename[];

        visibleModal: boolean
        setVisibleModal: React.Dispatch<React.SetStateAction<boolean>>

        onCallBack?: () => void
    }) => JSX.Element;
    modalInvitationMember?: (props: {
        groupId?: string;
        organizationId: string;
        dataRoles?: ICodename[];
        dataGroups?: ICodename[];
        onCallBack?: () => void
    }) => JSX.Element;
}

const StaffStep = (props: IStaffStepProps & ILableOrganization) => {
    const strings = useStrings();

    const {
        clientId,
        language,
        userInfo,
    } = useCommonComponentContext();

    const { onChangeStatusMember } = useContainerStaff();
    const { onResendInvitation } = useContainerInvitation();

    const [userIdDelete, setUserIdDelete] = useState<string>("");
    const [userIdSelected, setUserIdSelected] = useState<string>("");
    const [visibleModalStaff, setVisibleModalStaff] = useState(false);

    const newLableStaff = useMemo(() => (
        (props.lableStaff || strings.Common.STAFF).toLowerCase()
    ), [props.lableStaff, strings]);

    const newLableGroup = useMemo(() => (
        (props.lableGroup || strings.Common.GROUP).toLowerCase()
    ), [props.lableGroup, strings]);

    const newDataRowByStaff: any[] = useMemo(() => {
        let staffList: any[] = [];

        props.dataRowByStaff.forEach((item) => {
            let roleNames: string[] = [];
            let arrRoleTypes: number[] = [];
            let userGroupName: string[] = [];

            if (Helpers.isNullOrEmpty(item.invitation)) {
                roleNames = [...item.userRoles || []].map((el: any) => el.roleName);
                userGroupName = [...item.groups || []].map((el: any) => el.name?.value?.[language]);
                arrRoleTypes = [...item.userRoles || []].map((e: any) => RoleHelpers.getRole(Number(e.roleType)).roleDetailType);
            } else {
                roleNames = item.invitation?.roleNames;
                userGroupName = [...item.invitation?.groupNames || []].map((el: any) => el.value?.[language]);
            }

            staffList.push({
                id: item.id,
                userId: item.userId,
                userCode: item.userCode,
                invitationId: item.invitation?.id,

                email: item.email,
                avatarId: item.avatarId,
                lastName: item.lastName,
                firstName: item.firstName,
                avatarUrl: item.avatarUrl,
                phoneNumber: item.phoneNumber,

                roleNames: roleNames,
                groupNames: userGroupName,
                arrRoleTypes: arrRoleTypes,

                status: item.status,
            });
        });

        return staffList;
    }, [props.dataRowByStaff, language, userInfo?.userProfile.identityId]);

    const actionList = (row: any) => {
        let isEdit = true;
        let isDelete = true;
        if ([...row.arrRoleTypes || []].length > 0) {
            isEdit = Math.min(...row.arrRoleTypes) <= RoleHelpers.getRole(Number(userInfo?.userProfile?.roleType)).roleDetailType;
            isDelete = Math.min(...row.arrRoleTypes) < RoleHelpers.getRole(Number(userInfo?.userProfile?.roleType)).roleDetailType;
        }

        return [
            isEdit &&
            !props.hidenActionUpdate &&
            {
                key: "edit",
                iconName: "edit",
                title: strings.Common.EDIT,
                callback: (row: any) => {
                    setUserIdSelected(row.userId);
                    setVisibleModalStaff(true);
                },
            },

            isDelete &&
            !props.hidenActionDelete &&
            (row.userId !== userInfo?.userProfile.identityId) &&
            {
                key: "delete",
                iconName: "delete",
                title: strings.Common.DELETE,
                callback: (row: any) => { setUserIdDelete(row.userId) },
            },

            isDelete &&
            !props.hidenActionUpdate &&
            (row.userId !== userInfo?.userProfile.identityId) &&
            (row.status === Status.Active || row.status === Status.Inactive) &&
            {
                key: "inactive",
                iconName: (Number(row.status) === Status.Active) ? "close" : "check",
                title: (Number(row.status) === Status.Active) ? strings.Common.IN_ACTIVE : strings.Common.ACTIVE,
                callback: (row: any) => {
                    onChangeStatusMember({
                        onCallBack: async () => {
                            await props.onCallBack();
                        },
                        params: {
                            id: row.userId,
                            clientId: clientId,
                            status: Number(row.status),
                            organizationId: props.organizationId,
                        },
                    });
                },
            },

            !props.hidenActionUpdate &&
            (row.userId !== userInfo?.userProfile.identityId) &&
            (row.status === Status.PendingInvitation || row.status === Status.Decline) &&
            {
                key: "resend",
                iconName: "resend",
                title: strings.INVITATION.RESEND_INVITATION,
                callback: (row: any) => {
                    onResendInvitation({
                        id: row.invitationId,
                        onCallBack: () => {
                            props.onCallBack();
                        },
                    });
                },
            },
        ] as any;
    };

    const dataColumns = useMemo(() => [
        {
            Header: strings.Staff.FULL_NAME, accessor: "firstName", width: "250px",
            Cell: (row: any) => {
                const nameTemp = `${row?.row?.original?.lastName || ""} ${row?.row?.original?.firstName || ""}`.trim();

                return (
                    <Box display="flex" alignItems="center">
                        <Avatar
                            alt="avt-staff"
                            text={row?.value}
                            src={row?.row?.original?.avatarUrl}
                            sx={{
                                width: "36px",
                                height: "36px",
                                objectFit: "cover",
                                marginRight: "8px",
                                borderRadius: "50%",
                            }}
                        />
                        <Box display="grid">
                            <Typography variant="caption" fontWeight="medium" color="text">
                                {nameTemp || row?.row?.original?.email}
                            </Typography>
                            {!Helpers.isNullOrEmpty(row?.row?.original?.phoneNumber) &&
                                <Typography
                                    color="secondary"
                                    variant="caption"
                                >
                                    sđt:&nbsp;{row?.row?.original?.phoneNumber || ""}
                                </Typography>
                            }
                            {!Helpers.isNullOrEmpty(row?.row?.original?.email) &&
                                <Typography
                                    color="secondary"
                                    variant="caption"
                                >
                                    email:&nbsp;{row?.row?.original?.email || ""}
                                </Typography>
                            }
                        </Box>
                    </Box>
                )
            },
        },
        {
            Header: Helpers.capitalizeFirstLetter(strings.format(strings.Staff.WORK_GROUPS, newLableGroup)), accessor: "groupNames",
            Cell: (row: any) => <Box display="grid">
                {
                    [...row.value || []].map((el: any, index: number) => (
                        <Typography
                            color="text"
                            variant="caption"
                            fontWeight="medium"
                            key={`user_groups_${index}`}
                        >
                            {el}
                        </Typography>
                    ))
                }
            </Box>,
        },
        {
            Header: strings.format(strings.Staff.STAFF_PERMISSION, newLableStaff), accessor: "roleNames",
            Cell: (row: any) => <Box display="grid">
                {
                    [...row.value || []].map((el: any, index: number) => (
                        <Typography
                            color="text"
                            variant="caption"
                            fontWeight="medium"
                            key={`user_roles_${index}`}
                        >
                            {el}
                        </Typography>
                    ))
                }
            </Box>,
        },
        {
            Header: strings.Common.STATUS, accessor: "status", width: "170px",
            Cell: (row: any) => (
                <CustomStatusCell
                    status={Number(row?.row.original?.status)}
                    statusByScreen={StatusByScreen.screenStaff}
                />
            ),
        },
    ], [strings, newLableGroup, newLableStaff]);

    // #region Invite Member in Organization
    const RenderModalInviteMemberByOrganization = () => (
        props.modalInvitationMember
            ? props.modalInvitationMember({
                groupId: undefined,
                dataRoles: props.dataRoles,
                dataGroups: props.dataGroups,
                organizationId: props.organizationId || "0",
                onCallBack() {
                    props.onCallBack &&
                        props.onCallBack();
                },
            })
            : <ModalInvitationMember
                newDomain={props.newDomain}
                lableStaff={props.lableStaff}
                lableGroup={props.lableGroup}
                lableOrganization={props.lableOrganization}

                roleList={props.dataRoles || []}
                groupList={props.dataGroups || []}
                organizationId={props.organizationId}
                onCallBack={() => {
                    props.onCallBack();
                }}
            />
    );

    // #region Create Member in Organization
    const RenderModalCreateMemberByOrganization = () => (
        props.modalCreateMember
            ? props.modalCreateMember({
                groupId: undefined,
                dataRoles: props.dataRoles,
                dataGroups: props.dataGroups,
                organizationId: props.organizationId || "0",

                onCallBack() {
                    props.onCallBack &&
                        props.onCallBack();
                },
            })
            : (
                <Button onClick={() => { setVisibleModalStaff(true); }}>
                    {strings.Common.ADD_NEW}
                </Button>
            )
    );

    // #region Update Member in Organization
    const RenderModalUpdateMemberByOrganization = () => (
        props.modalUpdateMember
            ? props.modalUpdateMember({
                visibleModal: visibleModalStaff,
                setVisibleModal: setVisibleModalStaff,

                groupId: undefined,
                dataRoles: props.dataRoles,
                dataGroups: props.dataGroups,
                idDetailStaff: userIdSelected,
                organizationId: props.organizationId || "0",

                onCallBack() {
                    props.onCallBack &&
                        props.onCallBack();
                },
            })
            : (
                <ModalCreateUpdateMember
                    newDomain={props.newDomain}

                    visibleModal={visibleModalStaff}
                    setVisibleModal={setVisibleModalStaff}

                    lableStaff={props.lableStaff}
                    lableGroup={props.lableGroup}
                    lableOrganization={props.lableOrganization}

                    dataRoles={props.dataRoles}
                    dataGroups={props.dataGroups}
                    idDetailStaff={userIdSelected}
                    dataUserTitle={props.dataUserTitle}
                    organizationId={props.organizationId}
                    groupIdDefault={props.idGroupDefaultByOrg}

                    onClose={() => {
                        setVisibleModalStaff(false);
                        setUserIdSelected(undefined);
                    }}
                    onCallBack={() => {
                        props.onCallBack();
                    }}
                />
            )
    );

    return (
        <>
            <Box p={2}>
                <Box mb={2} sx={{
                    gap: 1,
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}>
                    <Typography variant="h5">
                        {strings.format(strings.Staff.TITLE_LIST_VIEW, newLableStaff)}
                    </Typography>

                    <Box gap={1} display="flex" flexWrap="wrap" alignItems="center">
                        {/* Modal Invite Member */}
                        {
                            (props.mode !== Mode.View) && !props.hidenActionInvation &&
                            <RenderModalInviteMemberByOrganization />
                        }
                        {/* Modal Create Member */}
                        {(props.mode !== Mode.View) && (!props.hidenActionCreate || !props.hidenActionUpdate) &&
                            <RenderModalCreateMemberByOrganization />
                        }
                    </Box>
                </Box>

                {/* List Staff */}
                <DataTable
                    isLocal
                    pageNumber={1}
                    rowPerPage={Constants.ROW_PER_PAGE}
                    totalCount={props.dataRowByStaff.length}
                    hideActionMenu={props.mode === Mode.View}

                    table={{
                        columns: dataColumns,
                        rows: newDataRowByStaff,
                    }}

                    actionList={actionList}

                />
            </Box>

            {!Helpers.isNullOrEmpty(userIdDelete) &&
                <ModalHandelDeleteMember
                    lable={newLableStaff}
                    hidenCheckBox={props.hidenActionDeleteAllService}
                    openDelete={!Helpers.isNullOrEmpty(userIdDelete)}
                    params={{
                        userId: userIdDelete,
                        clientId: clientId,
                        organizationId: props.organizationId,
                    }}
                    onCancle={() => {
                        setUserIdDelete("");
                    }}
                    onOk={() => {
                        setUserIdDelete("");
                        props.onCallBack();
                    }}
                />
            }

            {visibleModalStaff &&
                <RenderModalUpdateMemberByOrganization />
            }
        </>
    );
};

export default StaffStep;